<template>
    <section>
        <div class="section3" style="display: flex; height: 100vh; position: relative;">
            <div style="display: flex; flex-direction: column; padding-top: 115px">
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-bottom: 48px;">
                    <p data-aos="fade-up"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 700; color: white; text-align: center; color: #000000;">
                        교육의 혁신으로<br>
                        모두의 꿈을 채울 때까지
                    </p>
                </div>
                <div data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out">
                    <div style="width: 100%; display: flex; justify-content: space-between; border-bottom: 1px solid #E7E7E7; padding: 11px 20px">
                        <div @mousedown="activeIndex = -1" @mouseup="activeIndex = index" v-for="(item, index) in historyList" :key="index">
                            <p :style="{color: index == activeIndex ? 'black' : '#CCCCCC'}" style="font-size: 18px; font-weight: 700; transition: all 0.3s ease;">{{item.year}}</p>
                        </div>
                    </div>
                    <transition name="fade">
                        <p v-if="activeIndex > -1" style="animation: position 0.3s ease; font-size: 15px; font-weight: 700; color: black; line-height: 1.5; padding: 17px 20px">
                            {{historyList[activeIndex].title}}<br>
                            <span style="font-size: 15px; font-weight: 400; color: #5A5A5A">{{historyList[activeIndex].detail}}</span>
                        </p>
                    </transition>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    },
    data() {
        return {
            activeIndex: 0,
            historyList: [
                {
                    'year': '2023',
                    'title': '필드유 연혁 준비중1',
                    'detail':'더 많은 학생들이 공부에 집중할 수 있도록 노력하고 있습니다.\n연혁이 준비되는대로 업데이트 예정입니다.'
                },{
                    'year': '2022',
                    'title': '필드유 연혁 준비중2',
                    'detail': '더 많은 학생들이 공부에 집중할 수 있도록 노력하고 있습니다.\n연혁이 준비되는대로 업데이트 예정입니다.'
                },{
                    'year': '2021',
                    'title': '필드유 연혁 준비중3',
                    'detail': '더 많은 학생들이 공부에 집중할 수 있도록 노력하고 있습니다.\n연혁이 준비되는대로 업데이트 예정입니다.'
                },{
                    'year': '2020',
                    'title': '필드유 연혁 준비중4',
                    'detail': '더 많은 학생들이 공부에 집중할 수 있도록 노력하고 있습니다.\n연혁이 준비되는대로 업데이트 예정입니다.'
                },{
                    'year': '2019',
                    'title': '필드유 연혁 준비중5',
                    'detail': '더 많은 학생들이 공부에 집중할 수 있도록 노력하고 있습니다.\n연혁이 준비되는대로 업데이트 예정입니다.'
                },
            ]
        }
    },
    methods: {
    }
    
}
</script>
<style>
    .section3 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    @keyframes position {
        from {
            margin-top: 50px
        } to {
            margin-top: 0px
        }
    }
</style>